import React from "react";
import { Space, Tag } from "antd";
import { AppstoreAddOutlined, PlusCircleOutlined, LoginOutlined, LogoutOutlined, CheckCircleOutlined, CloseCircleOutlined, MinusOutlined, BorderOutlined } from "@ant-design/icons";
import { ButtonItem } from "../../../../../Components/Items";

const ETIQUETA_POR_MODO = {
  agregando_seccion: "Clic en el lienzo para colocar la sección",
  agregando_nodo: "Clic para colocar nodos (se alinean horizontal/vertical con el anterior) - sigue hasta cancelar",
  eligiendo_inicio: "Clic en un nodo para marcarlo como INICIO de picking",
  eligiendo_fin: "Clic en un nodo para marcarlo como FIN de picking",
};

//Barra de acciones del editor: agregar sección/nodo, definir nodo inicio/fin de picking, validar el mapa.
const BarraHerramientasMapa = ({ modo, onAgregarSeccion, onAgregarPasillo, onAgregarRack, onAgregarNodo, onElegirInicio, onElegirFin, onValidar, onCancelarModo }) => {
  return (
    <div style={{ display: "flex", alignItems: "center", marginBottom: 12, flexWrap: "nowrap", gap: 8, overflowX: "auto" }}>
      <Space style={{ flexShrink: 0 }}>
        <ButtonItem cyan size="small" icon={<AppstoreAddOutlined />} onClick={onAgregarSeccion} disabled={!!modo}>
          Agregar sección
        </ButtonItem>
        <ButtonItem petroleo size="small" icon={<MinusOutlined />} onClick={onAgregarPasillo} disabled={!!modo}>
          Agregar pasillo
        </ButtonItem>
        <ButtonItem turquesa size="small" icon={<BorderOutlined />} onClick={onAgregarRack} disabled={!!modo}>
          Agregar rack
        </ButtonItem>
        <ButtonItem azulMarino size="small" icon={<PlusCircleOutlined />} onClick={onAgregarNodo} disabled={!!modo}>
          Agregar nodo
        </ButtonItem>
        <ButtonItem lila size="small" icon={<LoginOutlined />} onClick={onElegirInicio} disabled={!!modo}>
          Definir inicio
        </ButtonItem>
        <ButtonItem naranja size="small" icon={<LogoutOutlined />} onClick={onElegirFin} disabled={!!modo}>
          Definir fin
        </ButtonItem>
        <ButtonItem olivo size="small" icon={<CheckCircleOutlined />} onClick={onValidar} disabled={!!modo}>
          Validar mapa
        </ButtonItem>
      </Space>
      {modo && (
        <Tag color="processing" style={{ padding: "4px 10px", fontSize: 12, flexShrink: 0, whiteSpace: "normal" }}>
          {ETIQUETA_POR_MODO[modo] || modo}
          <CloseCircleOutlined style={{ marginLeft: 8, cursor: "pointer" }} onClick={onCancelarModo} />
        </Tag>
      )}
    </div>
  );
};

export default BarraHerramientasMapa;
